// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import fastClick from 'fastclick'   //移动端click300毫秒延迟
import moment from 'moment'   //时间自动转化问题
import 'lib-flexible'  //解决自适应
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
import { Tabbar, TabItem } from 'mint-ui';
import VueWechatTitle from 'vue-wechat-title'  //动态添加标题
import Meta from 'vue-meta'   //动态修改meta内容
import { InfiniteScroll } from 'mint-ui';
import { Spinner } from 'mint-ui';

//import VueQuillEditor from 'vue-quill-editor'
//import 'quill/dist/quill.core.css'
//import 'quill/dist/quill.snow.css'
//import 'quill/dist/quill.bubble.css'

Vue.component(Spinner.name, Spinner);
Vue.use(InfiniteScroll);
//Vue.use(VueQuillEditor);
Vue.use(MintUI)
Vue.component(Tabbar.name, Tabbar);
Vue.component(TabItem.name, TabItem);
Vue.use(Meta)
Vue.use(VueWechatTitle)
Vue.config.productionTip = false
fastClick.attach(document.body)  //自带方法
//全局过滤器  转换时间
Vue.filter('dateFmt', (input, formatString = "YYYY-MM-DD") => {
  return moment(input).format(formatString)
})
//解决路由跳转新页面，默认在页面底部问题
router.afterEach((to,from,next) => {
    window.scrollTo(0,0);
})
/* eslint-disable no-new */

new Vue({
  el: '#app',
  router,   //路由配置的内容
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js